import { render, staticRenderFns } from "./privacyService.vue?vue&type=template&id=108af263&scoped=true"
import script from "./privacyService.vue?vue&type=script&lang=js"
export * from "./privacyService.vue?vue&type=script&lang=js"
import style0 from "./privacyService.vue?vue&type=style&index=0&id=108af263&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108af263",
  null
  
)

export default component.exports